import { Tooltip as MuiTooltip } from '@material-ui/core';
import { ComponentProps } from 'react';

/**
 * Tooltip component.
 * Based on the tooltip component from material-ui.
 *
 * @param {ComponentProps<typeof MuiTooltip>} tooltipProps - component props
 *
 * @returns {JSX.Element}
 */
export function Tooltip({ children, ...props }: ComponentProps<typeof MuiTooltip>): JSX.Element {
  return (
    <MuiTooltip arrow {...props}>
      {children}
    </MuiTooltip>
  );
}
